export default {
	productPages: {
		parameters: {
			recommendedMinimum: 3,
			recommendedMaximum: 6,
			acceptableMaximum: 7,
			acceptableMinimum: 1,
		},
	},
};

